import { getConfig } from '@edx/frontend-platform';
import { useQuery, keepPreviousData } from '@tanstack/react-query';

import { fetchOngoingCoursesList } from './api';

const FALLBACK_IMAGE = 'https://images.unsplash.com/photo-1515879218367-8466d910aaa4?auto=format&fit=crop&w=1200&q=60';

const buildHomeUrl = (courseId) => {
  if (!courseId) return null;
  const learningBase = getConfig().LEARNING_BASE_URL || '';
  const base = learningBase.includes('/learning') ? learningBase : `${learningBase}/learning`;
  return `${base}/course/${courseId}/home`;
};

const useOngoingCoursesQuery = ({
  search = '',
  status = 'all',
  limit = 20,
  offset = 0,
} = {}) => {
  const query = useQuery({
    queryKey: ['ongoingCoursesList', { search, status, limit, offset }],
    queryFn: () => fetchOngoingCoursesList({
      search, status, limit, offset,
    }),
    placeholderData: keepPreviousData,
  });

  const courses = (query.data?.courses || []).map((course) => ({
    id: course.courseId || course.title,
    courseId: course.courseId,
    title: course.title,
    homeUrl: course.homeUrl || buildHomeUrl(course.courseId),
    progressPercent: course.progressPercent ?? 0,
    imageUrl: course.imageUrl || FALLBACK_IMAGE,
    certificateIsEarned: !!course.certificateIsEarned,
    certificateUrl: course.certificateUrl || null,
    // null when the course has no certificate-expiry policy, so the UI shows
    // no expiry state at all rather than claiming it never expires.
    certificateStatus: course.certificateStatus || null,
    certificateExpiresAt: course.certificateExpiresAt || null,
  }));

  return {
    courses,
    pagination: query.data?.pagination || { total: 0, limit, offset },
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
  };
};

export default useOngoingCoursesQuery;
